import { action } from '@play-co/replicant';
import createActions from '../config/actions/createActions';
import { initializeTreasureExpressEvent } from './treasureExpress.modifiers';
import { Difficulty, treasureExpressSchedule } from './treasureExpress.ruleset';

export const treasureExpressCheats = createActions({
  cheat_resetTreasureExpress: action((state, _, api) => {
    // Clear the treasureExpress entries
    state.treasureExpress = {
      entries: {},
    };
  }),

  cheat_progressTreasureExpress: action((state, _, api) => {
    const now = api.date.now();
    // No active event, no score.
    const currentEventId = treasureExpressSchedule.getID(now);
    if (!currentEventId) return;
    initializeTreasureExpressEvent(state, now);
    state.treasureExpress.entries[currentEventId].tickets += 3;
  }),

  cheat_setTreasureExpressDifficulty: action(
    (state, difficulty: Difficulty, api) => {
      const now = api.date.now();
      // No active event, no score.
      const currentEventId = treasureExpressSchedule.getID(now);
      if (!currentEventId) return;
      initializeTreasureExpressEvent(state, now);

      // Check if the difficulty is valid
      if (!['easy', 'normal', 'hard'].includes(difficulty)) {
        throw new Error(`Invalid difficulty: ${difficulty}`);
      }

      state.treasureExpress.entries[currentEventId].difficulty = difficulty;
      console.log(
        `Treasure Express difficulty set to ${difficulty} for event ${currentEventId}`,
      );
    },
  ),
});
